import {
	BOMCt,
	__DEFAULT__DSP,
	TreeBTP,
	LoopGiaiDoan,
	BOM,
} from "./../bom-model/bom.model";
import { BOMBtpDialogComponent } from "./../bom-btp-dialog/bom-btp-dialog.component";
import { BOMService } from "./../bom-service/bom.service";
import { DungChungService } from "app/views/pages/nfc/dung-chung/__services/dung-chung.service";
import {
	Component,
	OnInit,
	Input,
	ChangeDetectionStrategy,
	HostListener,
	ElementRef,
	ViewChild,
	ChangeDetectorRef,
	ViewRef,
	Output,
	EventEmitter,
	ViewEncapsulation,
} from "@angular/core";
import {
	Observable,
	fromEvent,
	of,
	BehaviorSubject,
	ReplaySubject,
} from "rxjs";
import { distinctUntilChanged, tap, debounceTime } from "rxjs/operators";
import { Moment } from "moment";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TokenStorage } from "app/core/auth/_services/token-storage.service";
import { LayoutUtilsService } from "app/core/_base/crud/utils/layout-utils.service";
import {
	RdBoM,
	RdBoMCt,
} from "../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonConFig } from "../../../dung-chung/__model/common_config.model";
import { MatDialog } from "@angular/material";
import { __DEFAULT__IDLOAIHH } from "../bom-model/bom.model";
import { number } from "@amcharts/amcharts4/core";
import { DecimalPipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: "kt-bom-step-one",
	templateUrl: "./bom-step-one.component.html",
	styleUrls: ["../bom.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [DecimalPipe],
})
export class BOMStepOneComponent implements OnInit {
	CONFIG: CommonConFig;
	@Input() Input: FormGroup = null;
	@Input() edit: boolean = false;
	@Input() set InputNPL(value) {
		if (value && value["Details"] && value["Details"].length > 0) {
			this.ListDSNguyenLieu = [];
			value["Details"].forEach((m) => {
				this.ListDSNguyenLieu.push(m);
				if (m.BOMNPLChild && m.BOMNPLChild.length > 0) {
					m.BOMNPLChild.forEach((c) => {
						this.ListDSNguyenLieu.push(c);
					});
				}
			});
			this.Id = value["Master"].BoM_ThuHoi;
			this.Code =  value["Master"].BoM_ThuHoi_Number;
			this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		}
		if (value && value["DongSanPham"]) {
			this.DongSanPhamEdit = value["DongSanPham"];
			this.addListHHEdit(this.DongSanPhamEdit);
		}
	}
	@Output() OutputMainForm = new EventEmitter<FormGroup>();
	@Output() OutputTree = new EventEmitter<TreeBTP[]>();
	@Output() OutputList = new EventEmitter<BOMCt[]>();
	@Output() OutputDSP = new EventEmitter<number>();
	@Output() clear = new EventEmitter<boolean>();

	MainForm: FormGroup;
	MainForm2: FormGroup;
	DongSanPhamEdit: number;
	DongSanPhamPre: number;
	Id: number;
	Code: string;

	displayedColumnsf = [];
	availableColumnsf = [
		{
			stt: 1,
			name: "#",
			displayName: "#",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "MANGUYENLIEU",
			displayName: "Mã nguyên liệu",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "TENNGUYENLIEU",
			displayName: "Tên nguyên liệu",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "HIEUSUATNLTRUOCTRON",
			displayName: "Hiệu suất NL trước trộn",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 6,
			name: "TYLEPHAMTRAMME",
			displayName: "Tỷ lệ trộn(%)/mẻ",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 99,
			name: "ACTIONS",
			displayName: "Thao tác",
			alwaysChecked: false,
			isShow: true,
		},
	];

	selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
	ListDSNguyenLieu: BOMCt[] = [];

	list_QTSX: any[] = [];
	QTSX_FilterCtrl: string = "";
	filtered_QTSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_ThanhPham: any[] = [];
	ThanhPham_FilterCtrl: string = "";
	filtered_ThanhPham: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_NL: any[] = [];
	NL_FilterCtrl: string = "";
	filtered_NL: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_BTP: any[] = [];
	BTP_FilterCtrl: string = "";
	filtered_BTP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	list_HangHoa: any[] = [];
	ListGiaiDoan: LoopGiaiDoan[] = [];

	ListDongSanPham = __DEFAULT__DSP.LIST_DSP;

	constructor(
		private MainFormFB: FormBuilder,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private service: BOMService,
		public dialog: MatDialog,
		private decPIpe: DecimalPipe,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.CONFIG = new CommonConFig();
		this.GetListThanhPham();
		this.GetListQTSX();
		this.GetSoGiaiDoan();
		this.MainForm = this.Input;
		this.showColumnsInTablef();
		this.applySelectedColumnsf();
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	showColumnsInTablef() {
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			if (this.availableColumnsf[i].isShow == false) {
				this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			}
		}
	}
	applySelectedColumnsf() {
		let _selectedColumns = this.selectedColumnsf.selected;
		this.selectedColumnsf = new SelectionModel<any>(
			true,
			this.availableColumnsf
		);
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (
					this.availableColumnsf[i].name == _selectedColumns[j].name
				) {
					this.selectedColumnsf.toggle(this.availableColumnsf[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumnsf.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumnsf = _applySelectedColumns;
	}

	async GetListQTSX() {
		let res = await this.service.GetListQTSX().toPromise();
		if (res && res.status === 1) {
			this.list_QTSX = res.data;
			this.filtered_QTSX.next(this.list_QTSX.slice());
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}
	filterQTSX() {
		if (!this.list_QTSX) {
			return;
		}
		let search = this.QTSX_FilterCtrl;
		if (!search) {
			this.filtered_QTSX.next(this.list_QTSX.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_QTSX.next(
			this.list_QTSX.filter(
				(ts) =>
					ts.Ma_QTSX.toLowerCase().indexOf(search) > -1
					|| ts.HangHoaName.toLowerCase().indexOf(search) > -1
					|| ts.Ma_QTSX_Text.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetectView();
	}

	async GetListThanhPham() {
		let res = await this.service.GetListThanhPham().toPromise();
		if (res && res.status === 1) {
			this.list_HangHoa = res.data ? res.data : [];
			this.list_ThanhPham = res.data
				.filter((ts) => ts.IdLoaihh == 4)
				.sort((a, b) => {
					return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
				});
			this.filtered_ThanhPham.next(this.list_ThanhPham.slice());
			this.list_BTP = res.data.filter((ts) => ts.IdLoaihh == 5);
			this.list_BTP = this.list_BTP.sort(function (a, b) {
				return a.Ma - b.Ma;
			});
			this.filtered_BTP.next(this.list_BTP.slice());
			this.list_NL = res.data.filter(
				(ts) =>
					ts.IdLoaihh == 1 ||
					ts.IdLoaihh == 2 ||
					ts.IdLoaihh == 3 ||
					ts.IdLoaihh == 6
			);
			this.list_NL = this.list_NL.sort(function (a, b) {
				return a.Ma - b.Ma;
			});
			this.filtered_NL.next(this.list_NL.slice());

			if (this.ListDSNguyenLieu.length > 0 && this.DongSanPhamEdit)
				this.addListHHEdit(this.DongSanPhamEdit);
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}

	filterThanhPham() {
		if (!this.list_ThanhPham) {
			return;
		}
		let search = this.ThanhPham_FilterCtrl;
		if (!search) {
			this.list_ThanhPham = this.list_HangHoa
				.filter((ts) => ts.IdLoaihh == 4)
				.sort((a, b) => {
					return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
				});
			return;
		} else {
			search = search.toLowerCase().normalize("NFC");
		}
		this.list_ThanhPham = this.list_HangHoa
			.filter(
				(ts) =>
					((ts.Ma
						? ts.Ma.toLowerCase().normalize("NFC").indexOf(search) >
						  -1
						: false) ||
						(ts.Ten
							? ts.Ten.toLowerCase()
									.normalize("NFC")
									.indexOf(search) > -1
							: false)) &&
					ts.IdLoaihh == 4
			)
			.sort((a, b) => {
				return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
			});

		this.changeDetectView();
	}
	filterBTP() {
		if (!this.list_BTP) {
			return;
		}
		let search = this.BTP_FilterCtrl;
		if (!search) {
			this.filtered_BTP.next(this.list_BTP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_BTP.next(
			this.list_BTP.filter(
				(ts) =>
					(ts.Ma
						? ts.Ma.toLowerCase().indexOf(search) > -1
						: false) ||
					(ts.Ten ? ts.Ten.toLowerCase().indexOf(search) > -1 : false)
			)
		);
		this.changeDetectView();
	}
	filterNL() {
		if (!this.list_NL) {
			return;
		}
		let search = this.NL_FilterCtrl;
		if (!search) {
			this.filtered_NL.next(this.list_NL.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_NL.next(
			this.list_NL.filter(
				(ts) =>
					(ts.Ma
						? ts.Ma.toLowerCase().indexOf(search) > -1
						: false) ||
					(ts.Ten ? ts.Ten.toLowerCase().indexOf(search) > -1 : false)
			)
		);
		this.changeDetectView();
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}

	changeThanhPham() {
		if (this.list_ThanhPham.length > 0) {
			var controls = this.MainForm.controls;
			var itemTP = this.list_ThanhPham.filter(
				(x) => x.Id == +controls["MATHANHPHAM"].value
			);
			if (itemTP.length > 0)
				controls["TENTHANHPHAM"].setValue(itemTP[0].Ten);
			var dsp = this.findDongSanPham(+controls["MATHANHPHAM"].value);
			if (this.ListDSNguyenLieu.length > 0) {
				switch (dsp) {
					case __DEFAULT__DSP.AD_FD: {
						this.ListDSNguyenLieu[0].IsNLC = true;
						if (this.DongSanPhamPre == __DEFAULT__DSP.HON_HOP) {
							this.ListDSNguyenLieu = [];
							this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
						}
						break;
					}
					case __DEFAULT__DSP.VIEN: {
						this.ListDSNguyenLieu[0].IsNLC = false;
						if (this.DongSanPhamPre == __DEFAULT__DSP.HON_HOP) {
							this.ListDSNguyenLieu = [];
							this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
						}
						break;
					}
					case __DEFAULT__DSP.HON_HOP: {
						if (
							this.DongSanPhamPre == __DEFAULT__DSP.AD_FD ||
							this.DongSanPhamPre == __DEFAULT__DSP.VIEN
						) {
							this.ListDSNguyenLieu = [];
							this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
						}
						break;
					}
				}
			}
			//this.bindingOutputTree();
			this.DongSanPhamPre = dsp;
			this.bindingOutputListNPL();
			if (dsp)
				this.OutputDSP.emit(
					this.findDongSanPham(+controls["MATHANHPHAM"].value)
				);
			this.changeDetect.detectChanges();
		}
	}

	findCodeThanhPham() {
		var controls = this.MainForm.controls;
		return controls["MATHANHPHAM"].value && this.list_ThanhPham.length > 0
			? this.list_ThanhPham.find(
					(x) => x.Id == +controls["MATHANHPHAM"].value
			  ).Ma
			: "";
	}

	findCodeNguyenLieu(arr: any[], Id: number) {
		var data =
			Id > 0 && arr && arr.length > 0 ? arr.find((x) => x.Id == Id) : "";
		return data ? data.Ma : "";
	}

	changQTSX() {
		let idqt = this.MainForm.controls["MASOQTSX"].value;
		let item = this.list_QTSX.find((x) => x.Id_QTSX == idqt);
		if (item)
			this.MainForm.controls["MATHANHPHAM"].setValue(item.HangHoa + "");
		this.changeThanhPham();
		this.changeDetect.detectChanges();
	}

	deleteMaQTSX() {
		var controls = this.MainForm.controls;
		controls["MASOQTSX"].setValue("");
		this.deleteMaSP();
		this.changeDetect.detectChanges();
	}

	deleteMaSP() {
		var controls = this.MainForm.controls;
		controls["MATHANHPHAM"].setValue("");
		controls["TENTHANHPHAM"].setValue("");
		this.ListDSNguyenLieu = [];
		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		this.changeDetect.detectChanges();
	}

	changeNL(item: BOMCt, i) {
		var data = item.ListHH.find((x) => x.Id == item.IdNL);
		this.ListDSNguyenLieu[i].MaNL = data.Ma;
		this.ListDSNguyenLieu[i].TenNL = data.Ten;
		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		//this.bindingOutputTree();
		this.bindingOutputListNPL();
		this.changeDetectView();
	}

	deleteItem(index: number) {
		if (this.ListDSNguyenLieu[index].LaBTP != null) {
			var listBTP = this.ListDSNguyenLieu.filter(
				(x) => x.LaBTP != null || (x.LaBTP == null && !x.ThuocBTP)
			)
				.map((x) => this.ListDSNguyenLieu.indexOf(x))
				.filter((x) => x > index);
			var indexLast =
				listBTP.length > 0 ? listBTP[0] : this.ListDSNguyenLieu.length;
			this.ListDSNguyenLieu = this.ListDSNguyenLieu.filter(
				(x) =>
					this.ListDSNguyenLieu.indexOf(x) < index ||
					this.ListDSNguyenLieu.indexOf(x) >= indexLast
			);
		} else {
			this.ListDSNguyenLieu.splice(index, 1);
		}
		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		this.bindingOutputListNPL();
		this.changeDetectView();
	}

	findCodeQTSX() {
		var obj =  null;
		if(this.MainForm.controls["MASOQTSX"].value && this.list_QTSX.length > 0){
			obj = this.list_QTSX.find((x) =>
					x.Id_QTSX == +this.MainForm.controls["MASOQTSX"].value
				);
		}
		return !obj ? "" : obj.Ma_QTSX_Text ? obj.Ma_QTSX_Text : obj.Ma_QTSX;

	}

	keyUpInput(event) {
		FunctionPublic.preventAlphaV2(event);
	}

	findDongSanPham(IdHH: number) {
		return this.list_ThanhPham.find((x) => x.Id == IdHH)
			? this.list_ThanhPham.find((x) => x.Id == IdHH).DongSanPham
			: 0;
	}

	openDialogBTP() {
		const listSelected = this.ListDSNguyenLieu.filter(
			(x) => x.LaBTP != null
		).map((x) => x.IdNL);
		const dialogRef = this.dialog.open(BOMBtpDialogComponent, {
			data: {
				data: this.list_BTP,
				listSelected: listSelected,
			},
			maxHeight: "90vh",
			width: "65vw",
		});

		dialogRef.afterClosed().subscribe((res) => {
			if (res && res.data) {
				var listBTPAfter = this.ListDSNguyenLieu.filter(
					(x) => x.LaBTP != null
				);
				var listBTPBeforeNoBOM = res.data.filter(
					(x) => x.LaBTP == false
				);
				var listBTPBeforeBOM = res.data.filter((x) => x.LaBTP == true);
				this.ListDSNguyenLieu = this.ListDSNguyenLieu.filter(
					(x) =>
						(x.LaBTP == null && x.ThuocBTP == null) ||
						listBTPBeforeNoBOM.findIndex(
							(a) => a.Id == x.IdNL || a.Id == x.ThuocBTP
						) > -1 ||
						listBTPBeforeBOM.findIndex(
							(a) => a.Id == x.IdNL || a.Id == x.ThuocBTP
						) > -1
				);

				listBTPBeforeNoBOM
					.filter(
						(x) =>
							this.ListDSNguyenLieu.findIndex(
								(a) => a.IdNL == x.Id
							) == -1
					)
					.forEach((r) => {
						let tmp = new BOMCt();
						tmp.IdNL = r.Id;
						tmp.MaNL = r.Ma;
						tmp.TenNL = r.Ten;
						tmp.LaBTP = r.LaBTP;
						tmp.IsNLC = false;
						tmp.HieuSuatNLTruocTron = 100;
						tmp.TyLeTronMe = 100;
						this.ListDSNguyenLieu.push(tmp);
						if (tmp.LaBTP == false) {
							let rw = new BOMCt();
							rw.HieuSuatNLTruocTron = 100;
							rw.TyLeTronMe = 100;
							rw.IsNLC = true;
							rw.ListHH = this.findHHWithLoaiHH__NL();
							rw.ListGroupHH = this.findGroupHH(rw.ListHH);
							rw.ThuocBTP = tmp.IdNL;
							this.ListDSNguyenLieu.push(rw);
						}
					});

				if (res.BOMBTP) {
					res.BOMBTP.filter(
						(x) =>
							this.ListDSNguyenLieu.findIndex(
								(a) => a.IdNL == x.IdNL
							) == -1
					).forEach((r) => {
						let tmp = new BOMCt();
						tmp.IdNL = r.IdNL;
						tmp.MaNL = r.MaNL;
						tmp.TenNL = r.TenNL;
						tmp.LaBTP = true;
						tmp.IsNLC = false;
						tmp.HieuSuatNLTruocTron = 100;
						tmp.TyLeTronMe = 100;
						this.ListDSNguyenLieu.push(tmp);
						r.NPL.forEach((c) => {
							let rw = new BOMCt();
							rw.IdNL = c.IdNL;
							rw.MaNL = c.MaNL;
							rw.TenNL = c.TenNL;
							rw.HieuSuatNLTruocTron = c.HieuSuatNLTruocTron;
							rw.TyLeTronMe = c.TyLeTronMe;
							rw.IsNLC = c.IsNLC;
							rw.ThuocBTP = c.ThuocBTP;
							this.ListDSNguyenLieu.push(rw);
						});
					});
				}
				this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
				this.changeDetectView();
			}
		});
	}

	findIndexOf(item: any) {
		let controls = this.MainForm.controls;
		if (!controls["MATHANHPHAM"].value)
			return this.ListDSNguyenLieu.indexOf(item) + 1;
		if (this.findDongSanPham(+controls["MATHANHPHAM"].value) == 3) {
			if (item.LaBTP != null || !item.ThuocBTP)
				return (
					this.ListDSNguyenLieu.filter(
						(x) => x.LaBTP != null || !x.ThuocBTP
					).indexOf(item) + 1
				);
			else return "";
		}
		return this.ListDSNguyenLieu.indexOf(item) + 1;
	}

	addMainFormOutput() {
		let controls = this.MainForm.controls;
		this.MainForm2 = this.MainFormFB.group({
			SOPHIEU: [{ value: controls["SOPHIEU"].value, disabled: true }],
			SOPHIEU_ENTER: [
				{ value: controls["SOPHIEU_ENTER"].value, disabled: true },
			],
			NGAYLAP: [{ value: controls["NGAYLAP"].value, disabled: true }],
			NGUOILAP: [{ value: controls["NGUOILAP"].value, disabled: true }],
			TRANGTHAI: [{ value: controls["TRANGTHAI"].value, disabled: true }],
			CODEQTSX: [
				{
					value: controls["MASOQTSX"].value
						? this.findCodeQTSX()
						: "",
					disabled: true,
				},
			],
			CODETHANHPHAM: [
				{
					value: controls["MATHANHPHAM"].value
						? this.findCodeThanhPham()
						: "",
					disabled: true,
				},
			],
			NAMETHANHPHAM: [
				{ value: controls["TENTHANHPHAM"].value, disabled: true },
			],
			LANBANHANH: [
				{ value: controls["LANBANHANH"].value, disabled: true },
			],
			NGAYBANHANH: [
				{
					value: moment(controls["NGAYBANHANH"].value).format(
						"YYYY-MM-DD[T]HH:mm:ss.SSS"
					),
					disabled: true,
				},
			],
			KHOILUONGDANKHAY: [
				{ value: controls["KHOILUONGDANKHAY"].value, disabled: true },
			],
			HIEUSUATDANKHAY: [
				{ value: controls["HIEUSUATDANKHAY"].value, disabled: true },
			],
			KHOILUONGTHANHPHAM: [
				{ value: controls["KHOILUONGTHANHPHAM"].value, disabled: true },
			],
			IDQTSX: [{ value: controls["MASOQTSX"].value, disabled: true }],
			NOIDUNGSUADOI: [
				{ value: controls["NOIDUNGSUADOI"].value, disabled: true },
			],
		});

		return this.MainForm2;
		// this.OutputMainForm.emit(this.MainForm2);
		// this.changeDetect.detectChanges();
	}

	// Update ngày 07/11/2020
	findGroupHH(data: any[]) {
		var arr = [];
		let obj = data.map((x) => {
			var rObj = {};
			if (x.IdLoaihh) {
				rObj["IdLoaiHH"] = x.IdLoaihh;
				rObj["TenLoaiHH"] = x.TenLoaihh;
			} else {
				rObj["IdLoaiHH"] = 0;
				rObj["TenLoaiHH"] = "Chưa cập nhật loại";
			}
			return rObj;
		});

		obj.forEach((x) => {
			if (arr.filter((a) => a.IdLoaiHH == x["IdLoaiHH"]).length == 0)
				arr.push(x);
		});
		return arr.sort((a, b) => a.IdLoaiHH - b.IdLoaiHH);
	}

	findHHWithLoaiHH(data: any[], loaihh: number[]) {
		return data
			.filter((x) => loaihh.indexOf(x.IdLoaihh) > -1)
			.sort((a, b) => {
				return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
			});
	}

	findHHWithLoaiHH__TP() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.THANHPHAM,
		]);
	}

	findHHWithLoaiHH__BTP() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.BANTHANHPHAM,
		]);
	}

	findHHWithLoaiHH__NL() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.NGUYENLIEU,
		]);
	}

	findHHWithLoaiHH__PL() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.PHULIEU,
			__DEFAULT__IDLOAIHH.BAOBI,
		]);
	}

	findHHWithLoaiHH__PLBTP() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.PHULIEU,
			__DEFAULT__IDLOAIHH.BANTHANHPHAM,
			__DEFAULT__IDLOAIHH.BAOBI,
		]);
	}

	findHHWithLoaiHH__PLBTPNL() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.NGUYENLIEU,
			__DEFAULT__IDLOAIHH.PHULIEU,
			__DEFAULT__IDLOAIHH.BANTHANHPHAM,
			__DEFAULT__IDLOAIHH.BAOBI,
		]);
	}

	findHHWithLoaiHH__PLNL() {
		return this.findHHWithLoaiHH(this.list_HangHoa, [
			__DEFAULT__IDLOAIHH.NGUYENLIEU,
			__DEFAULT__IDLOAIHH.PHULIEU,
			__DEFAULT__IDLOAIHH.BAOBI,
		]);
	}

	addRecordNL(index: number = -1) {
		let controls = this.MainForm.controls;
		var r = new BOMCt();
		r.clear();
		// Kiểm tra đã chọn mã thành phẩm
		if (!controls["MATHANHPHAM"].value) {
			this.layoutUtilsService.showErorr(
				"Vui lòng chọn sản phẩm trước khi thêm dữ liệu"
			);
			return false;
		}
		var dsp = this.findDongSanPham(+controls["MATHANHPHAM"].value);
		// Set theo từng dòng sản phẩm
		switch (dsp) {
			case __DEFAULT__DSP.AD_FD: {
				// Nếu chưa có dòng nào -> thêm nguyên liệu chính
				r.HieuSuatNLTruocTron = 100;
				r.TyLeTronMe = 100;
				r.IsNLC = this.ListDSNguyenLieu.length == 0;
				r.ListHH = r.IsNLC
					? this.findHHWithLoaiHH__NL()
					: this.findHHWithLoaiHH__PLBTPNL();
				r.ListGroupHH = this.findGroupHH(r.ListHH);
				this.ListDSNguyenLieu.push(r);
				break;
			}

			case __DEFAULT__DSP.VIEN: {
				r.HieuSuatNLTruocTron = 100;
				r.TyLeTronMe = 100;
				r.IsNLC = false;
				r.ListHH = this.findHHWithLoaiHH__PLBTPNL();
				r.ListGroupHH = this.findGroupHH(r.ListHH);
				this.ListDSNguyenLieu.push(r);
				break;
			}

			case __DEFAULT__DSP.HON_HOP: {
				r.HieuSuatNLTruocTron = 100;
				r.TyLeTronMe = 100;
				r.IsNLC = false;
				r.LaBTP = null;
				r.ThuocBTP = null;
				r.ListHH = this.findHHWithLoaiHH__PLNL();
				r.ListGroupHH = this.findGroupHH(r.ListHH);
				if (index > -1) {
					r.ThuocBTP = this.ListDSNguyenLieu[index].IdNL;
					var listBTP = this.ListDSNguyenLieu.filter(
						(x) =>
							x.LaBTP != null || (x.LaBTP == null && !x.ThuocBTP)
					)
						.map((x) => this.ListDSNguyenLieu.indexOf(x))
						.filter((x) => x > index);
					var indexLast =
						listBTP.length > 0
							? listBTP[0]
							: this.ListDSNguyenLieu.length;
					this.ListDSNguyenLieu.splice(indexLast, 0, r);
				} else {
					this.ListDSNguyenLieu.splice(
						this.ListDSNguyenLieu.length,
						0,
						r
					);
				}
				break;
			}
		}
		// Update lại danh sách
		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		this.changeDetectView();
		//this.bindingOutputTree();
		this.bindingOutputListNPL();
	}

	filterGroupHH(List: any[], IdGroup: number) {
		let arr = [];
		if (List) {
			List.forEach((x) => {
				if (IdGroup > 0 && x.IdLoaihh == IdGroup) arr.push(x);
				if (IdGroup == 0 && !x.IdGroup) arr.push(x);
			});
		}
		return arr;
	}

	createTreeStep2(): TreeBTP[] {
		var arrTree: TreeBTP[] = [];
		let controls = this.MainForm.controls;
		// Kiểm tra đã chọn mã thành phẩm
		if (
			!controls["MATHANHPHAM"].value ||
			this.ListDSNguyenLieu.length == 0
		) {
			return [];
		}
		var dsp = this.findDongSanPham(+controls["MATHANHPHAM"].value);
		// Set theo từng dòng sản phẩm
		switch (dsp) {
			case __DEFAULT__DSP.AD_FD: {
				var record = this.ListDSNguyenLieu.filter((x) => x.IsNLC);

				record.forEach((r) => {
					var t = new TreeBTP();
					t.clear();
					t.IdNLC = +r.IdNL;
					t.MaNLC = r.MaNL;
					t.TenNLC = r.TenNL;
					t.IdThanhPham = +controls["MATHANHPHAM"].value;
					t.MaThanhPham = this.list_ThanhPham.find(
						(x) => x.Id == +controls["MATHANHPHAM"].value
					).Ma;
					t.TenThanhPham = this.list_ThanhPham.find(
						(x) => x.Id == +controls["MATHANHPHAM"].value
					).Ten;
					t.ListLoopGiaiDoan = [];

					this.ListGiaiDoan.forEach((res) => {
						var l = new LoopGiaiDoan();
						l.clear();
						l.HieuSuat = 0;
						l.IdGiaiDoan = res["QtsxGiaidoanId"];
						l.TenGiaiDoan = res["TenGiaiDoan"];
						t.ListLoopGiaiDoan.push(l);
					});

					arrTree.push(t);
				});
				break;
			}

			case __DEFAULT__DSP.VIEN: {
				var t = new TreeBTP();
				t.clear();
				t.TenNLC = this.ListDSNguyenLieu.map((x) => x.TenNL).join(", ");
				t.IdThanhPham = +controls["MATHANHPHAM"].value;
				t.MaThanhPham = this.list_ThanhPham.find(
					(x) => x.Id == +controls["MATHANHPHAM"].value
				).Ma;
				t.TenThanhPham = this.list_ThanhPham.find(
					(x) => x.Id == +controls["MATHANHPHAM"].value
				).Ten;
				t.ListLoopGiaiDoan = [];

				this.ListGiaiDoan.forEach((res) => {
					var l = new LoopGiaiDoan();
					l.clear();
					l.HieuSuat = 0;
					l.IdGiaiDoan = res["QtsxGiaidoanId"];
					l.TenGiaiDoan = res["TenGiaiDoan"];
					t.ListLoopGiaiDoan.push(l);
				});

				arrTree.push(t);
				break;
			}

			case __DEFAULT__DSP.HON_HOP: {
				var record = this.ListDSNguyenLieu.filter(
					(x) => x.LaBTP != null
				);
				record.forEach((r) => {
					var t = new TreeBTP();
					t.clear();
					var nlc = this.ListDSNguyenLieu[
						this.ListDSNguyenLieu.indexOf(r) + 1
					];
					t.IdNLC = +nlc.IdNL;
					t.MaNLC = nlc.MaNL;
					t.TenNLC = nlc.TenNL;
					t.ListLoopGiaiDoan = [];

					this.ListGiaiDoan.forEach((res) => {
						if (
							this.ListGiaiDoan.indexOf(res) >
							BOM.DEFAULT__GIAIDOAN_BTP
						)
							return;
						var l = new LoopGiaiDoan();
						l.clear();
						if (
							this.ListGiaiDoan.indexOf(res) ==
							BOM.DEFAULT__GIAIDOAN_BTP
						) {
							l.IdBTP = +r.IdNL;
							l.MaBTP = r.MaNL;
							l.TenBTP = r.TenNL;
						}
						l.HieuSuat = 0;
						l.IdGiaiDoan = res["QtsxGiaidoanId"];
						l.TenGiaiDoan = res["TenGiaiDoan"];
						t.ListLoopGiaiDoan.push(l);
					});

					arrTree.push(t);
				});

				var tp = new TreeBTP();
				tp.clear();
				tp.TenNLC = "";
				tp.IdThanhPham = +controls["MATHANHPHAM"].value;
				tp.MaThanhPham = this.list_ThanhPham.find(
					(x) => x.Id == +controls["MATHANHPHAM"].value
				).Ma;
				tp.TenThanhPham = this.list_ThanhPham.find(
					(x) => x.Id == +controls["MATHANHPHAM"].value
				).Ten;
				tp.ListLoopGiaiDoan = [];

				this.ListGiaiDoan.forEach((res) => {
					if (
						this.ListGiaiDoan.indexOf(res) <
						BOM.DEFAULT__GIAIDOAN_BTP
					)
						return;
					var l = new LoopGiaiDoan();
					l.clear();
					l.HieuSuat = 0;
					l.IdGiaiDoan = res["QtsxGiaidoanId"];
					l.TenGiaiDoan = res["TenGiaiDoan"];
					tp.ListLoopGiaiDoan.push(l);
				});

				arrTree.push(tp);
				break;
			}
		}
		return arrTree;
	}

	filterHangHoa(item: BOMCt, index: number) {
		var search = this.NL_FilterCtrl;
		var listHHFull = this.list_HangHoa.filter(
			(x) =>
				item.ListGroupHH.map((a) => a.IdLoaiHH).indexOf(x.IdLoaihh) > -1
		);
		if (search && listHHFull) {
			search = search.toLowerCase();
			this.ListDSNguyenLieu[index].ListHH = listHHFull.filter(
				(ts) =>
					(ts.Ma
						? ts.Ma.toLowerCase()
								.normalize("NFC")
								.indexOf(search.normalize("NFC")) > -1
						: false) ||
					(ts.Ten
						? ts.Ten.normalize("NFC")
								.toLowerCase()
								.indexOf(search.normalize("NFC")) > -1
						: false)
			);
			this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
			return;
		}
		this.ListDSNguyenLieu[index].ListHH = listHHFull;
		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		return;
	}

	async GetSoGiaiDoan() {
		let res = await this.service.GetSoGiaiDoan().toPromise();
		if (res && res.status === 1) {
			this.ListGiaiDoan = res.data;
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}

	bindingOutputTree() {
		this.OutputTree.emit(this.createTreeStep2());
	}

	bindingOutputListNPL() {
		this.OutputList.emit(this.ListDSNguyenLieu);
	}

	changeHieuSuatNLTruocTron(event: any, item: BOMCt) {
		item.HieuSuatNLTruocTron = event ? Number(event) : 0;
		this.bindingOutputListNPL();
		this.changeDetectView();
	}

	changeTyLeTronMe(event: any, item: BOMCt) {
		item.TyLeTronMe = event ? Number(event) : 0;
		this.bindingOutputListNPL();
		this.changeDetectView();
	}

	updateCellMaster(event: any, columns: string) {
		this.MainForm.controls[columns].setValue(
			event ? Number(event.target.value) : 0
		);
		this.addMainFormOutput();
		this.changeDetectView();
	}

	filterGroupDSP(List: any[], IdGroup: number) {
		let arr = [];
		if (List) {
			List.forEach((x) => {
				if (IdGroup > 0 && x.DongSanPham == IdGroup) arr.push(x);
				if (IdGroup == 0 && !x.DongSanPham) arr.push(x);
			});
		}
		return arr;
	}

	isThuocBTPBOM(item: BOMCt) {
		if (!item.ThuocBTP) return null;
		return this.ListDSNguyenLieu.find((x) => x.IdNL == item.ThuocBTP).LaBTP;
	}

	addListHHEdit(__dsp: number) {
		switch (__dsp) {
			case __DEFAULT__DSP.AD_FD:
			case __DEFAULT__DSP.VIEN: {
				this.ListDSNguyenLieu.forEach((x) => {
					if (x.IsNLC) {
						x.ListHH = this.findHHWithLoaiHH__NL();
						x.ListGroupHH = this.findGroupHH(x.ListHH);
					} else {
						x.ListHH = this.findHHWithLoaiHH__PLBTPNL();
						x.ListGroupHH = this.findGroupHH(x.ListHH);
					}
				});
				break;
			}
			case __DEFAULT__DSP.HON_HOP: {
				this.ListDSNguyenLieu.forEach((x) => {
					if (x.IsNLC) {
						x.ListHH = this.findHHWithLoaiHH__NL();
						x.ListGroupHH = this.findGroupHH(x.ListHH);
					} else {
						x.ListHH = this.findHHWithLoaiHH__PLNL();
						x.ListGroupHH = this.findGroupHH(x.ListHH);
					}
				});
				break;
			}
		}

		this.ListDSNguyenLieu = [...this.ListDSNguyenLieu];
		this.changeDetectView();
	}

	formatNumber(item: any, columns: string) {
		item[columns] = this.decPIpe.transform(item[columns], "1.2-2");
	}

	listNPLError() {
		var flag = false;
		this.ListDSNguyenLieu.forEach((r) => {
			if (flag) return;
			if (
				!r.IdNL ||
				isNaN(Number(r.HieuSuatNLTruocTron)) ||
				r.HieuSuatNLTruocTron < 0 ||
				isNaN(Number(r.TyLeTronMe)) ||
				r.TyLeTronMe < 0
			)
				flag = true;
		});

		return flag;
	}

	doneStep1() {
		var HON_HOP = true;
		if (this.MainForm.controls["MATHANHPHAM"].value) {
			if (
				this.findDongSanPham(
					+this.MainForm.controls["MATHANHPHAM"].value
				) == __DEFAULT__DSP.HON_HOP
			) {
				if (
					this.ListDSNguyenLieu.filter((x) => x.LaBTP != null)
						.length == 0
				)
					HON_HOP = false;
			}
		}

		return (
			this.MainForm.invalid == false &&
			!this.listNPLError() &&
			this.ListDSNguyenLieu.length > 0 &&
			HON_HOP
		);
	}

	func__clear() {
		this.clear.emit(true);
	}

	routerLinkDetail(id){
		this.router.navigate(["/cong-thuc-dinh-muc/chi-tiet/"+id, {}]);
	}
}
